/**
 * Collection enhancements
 * – Subcategory carousel prev/next arrows
 *
 * Arrow behaviour:
 *   • Hidden entirely (display:none) when the track does not overflow
 *   • Faded out (opacity 0, non-interactive) at the far left / far right
 *   • Each click scrolls exactly one full visible page width
 */
(function () {
  'use strict';

  function initCarousel(wrapper) {
    var track   = wrapper.querySelector('.subcategory-nav__track');
    var btnPrev = wrapper.querySelector('.subcategory-nav__arrow--prev');
    var btnNext = wrapper.querySelector('.subcategory-nav__arrow--next');

    if (!track || !btnPrev || !btnNext) return;

    /* ── Arrow visibility ─────────────────────────────────── */
    function updateArrows() {
      var overflows = track.scrollWidth > track.clientWidth + 4;

      if (!overflows) {
        /* No overflow → hide both arrows (display:none, no layout space) */
        btnPrev.style.display = 'none';
        btnNext.style.display = 'none';
        return;
      }

      /* Overflow exists → reveal arrows, fade the one at the boundary */
      btnPrev.style.display = '';
      btnNext.style.display = '';

      var atStart = track.scrollLeft <= 4;
      var atEnd   = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;

      btnPrev.style.opacity       = atStart ? '0' : '1';
      btnPrev.style.pointerEvents = atStart ? 'none' : '';
      btnNext.style.opacity       = atEnd   ? '0' : '1';
      btnNext.style.pointerEvents = atEnd   ? 'none' : '';
    }

    /* ── Scroll one full visible page at a time ───────────── */
    btnPrev.addEventListener('click', function () {
      track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    });

    btnNext.addEventListener('click', function () {
      track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
    });

    /* ── Re-evaluate on scroll ────────────────────────────── */
    track.addEventListener('scroll', updateArrows, { passive: true });

    /* ── Re-evaluate on resize (e.g. orientation change) ──── */
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateArrows).observe(track);
    } else {
      window.addEventListener('resize', updateArrows);
    }

    /*
     * Defer the very first check until after the browser has painted
     * and images have started to affect layout — otherwise clientWidth
     * may be 0 or incomplete and arrows would show incorrectly.
     */
    requestAnimationFrame(function () {
      requestAnimationFrame(updateArrows);
    });
  }

  /* ── Collection description "Les mer" / "Skjul" (mobile only) */
  function initReadMore() {
    var wrap = document.querySelector('.collection-intro__desc-wrap');
    var desc = wrap && wrap.querySelector('.collection-intro__description');
    var btn  = wrap && wrap.querySelector('.collection-intro__read-more');
    if (!wrap || !desc || !btn) return;

    function setup() {
      /* Desktop: CSS removes clamp; make sure JS state is clean */
      if (window.innerWidth >= 750) {
        wrap.classList.remove('is-short', 'is-expanded');
        btn.style.display = 'none';
        return;
      }

      /*
       * Mobile: CSS already clamps from first paint.
       * Reset any previous JS state, then measure whether text actually overflows.
       */
      wrap.classList.remove('is-short', 'is-expanded');

      var overflows = desc.scrollHeight > desc.clientHeight + 2;
      if (overflows) {
        /* Text is longer than 2 lines — show "Les mer" at end of line 2 */
        btn.textContent = 'Les mer';
        btn.setAttribute('aria-expanded', 'false');
        btn.style.display = 'block';
      } else {
        /* Text fits — remove clamp so it shows in full, hide button */
        wrap.classList.add('is-short');
        btn.style.display = 'none';
      }
    }

    btn.addEventListener('click', function () {
      if (wrap.classList.contains('is-expanded')) {
        /* Collapse: remove expanded state, go back to clamped */
        wrap.classList.remove('is-expanded');
        btn.textContent = 'Les mer';
        btn.setAttribute('aria-expanded', 'false');
        /* btn.style.display stays 'block'; CSS repositions to absolute */
      } else {
        /* Expand: show full text, "Skjul" appears in normal flow below */
        wrap.classList.add('is-expanded');
        btn.textContent = 'Skjul';
        btn.setAttribute('aria-expanded', 'true');
        /* btn.style.display stays 'block'; CSS switches to position:static */
      }
    });

    /* CSS clamps from first paint — no rAF needed to avoid FOUC.
       We still use one rAF to ensure font metrics are ready for measuring. */
    requestAnimationFrame(setup);

    window.addEventListener('resize', setup);
  }

  /*
   * Produktgrid: hybrid statisk/infinite-scroll lasting
   *
   * Side 1 lastes statisk fra serveren (automatisk rulling er av), slik at
   * brukeren kan scrolle helt ned til FAQ/footer uten avbrudd. Et klikk på
   * "Vis flere produkter" aktiverer automatisk rulling for side 2 og utover.
   *
   * SEO-sikkerhetsnett: de ekte <a href="?page=2">-lenkene fra pagination.liquid
   * ligger alltid i DOM-en og fungerer uten JS. Når hybrid-modus er aktiv
   * skjules de kun visuelt (.visually-hidden) — de fjernes aldri fra DOM-en,
   * så Googlebot finner og kan følge dem uavhengig av knappe-/scroll-tilstand.
   */
  function initProductGridLoadMore() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;

    function initGrid() {
      var loadMoreWrapper = container.querySelector('#ProductGridLoadMore');
      var loadMoreButton  = container.querySelector('#ProductGridLoadMoreButton');
      var spinner         = container.querySelector('#ProductGridLoadMoreSpinner');
      var sentinel        = container.querySelector('#ProductGridSentinel');
      var seoPagination   = container.querySelector('.pagination-wrapper');
      var grid            = container.querySelector('#product-grid');

      if (!loadMoreWrapper || !loadMoreButton || !sentinel || !grid) return;

      var nextLink = seoPagination ? seoPagination.querySelector('a[rel="next"]') : null;
      var nextUrl = nextLink ? nextLink.href : null;
      var sectionId = grid.dataset.id;
      var isLoading = false;
      var observer = null;

      if (seoPagination) seoPagination.classList.add('visually-hidden');
      loadMoreWrapper.hidden = false;

      function loadNextPage() {
        if (isLoading || !nextUrl) return;
        isLoading = true;
        if (spinner) spinner.hidden = false;

        var separator = nextUrl.indexOf('?') === -1 ? '?' : '&';
        var fetchUrl = nextUrl + separator + 'section_id=' + encodeURIComponent(sectionId);

        fetch(fetchUrl)
          .then(function (response) { return response.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.getElementById('product-grid');
            var newPagination = doc.querySelector('.pagination-wrapper');
            var newNextLink = newPagination ? newPagination.querySelector('a[rel="next"]') : null;

            if (newGrid) {
              Array.prototype.slice.call(newGrid.children).forEach(function (item) {
                grid.appendChild(item);
              });
            }

            nextUrl = newNextLink ? newNextLink.href : null;
            if (!nextUrl && observer) observer.disconnect();
          })
          .catch(function () {
            /* nextUrl beholdes uendret — neste scroll inn i sentinel prøver på nytt */
          })
          .then(function () {
            isLoading = false;
            if (spinner) spinner.hidden = true;
          });
      }

      loadMoreButton.addEventListener('click', function () {
        loadMoreWrapper.hidden = true;
        if (!nextUrl) return;

        observer = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) loadNextPage();
        }, { rootMargin: '0px 0px 600px 0px' });

        observer.observe(sentinel);
      });
    }

    initGrid();

    /*
     * facets.js (filtrering/sortering) erstatter hele innholdet i
     * #ProductGridContainer ved filterendring. Vi lytter på direkte
     * barn-endringer på containeren (ikke subtree) for å fange nettopp
     * den utskiftingen — egne append-kall lenger nede i treet (ved
     * innlasting av flere produkter) trigger ikke denne observeren.
     */
    new MutationObserver(initGrid).observe(container, { childList: true });
  }

  /*
   * Produktgrid via Algolia InstantSearch — hybrid load-more → infinite scroll
   *
   * Denne kategorisiden rendrer det faktiske produktgridet med Algolias
   * infiniteHits-widget, som overskriver #ProductGridContainer over (Liquid-
   * pagineringen blir dermed stående igjen kun som SEO-sikkerhetsnett i rå
   * HTML for Googlebot). Algolia sin widget har en "Show more"-knapp
   * (.ais-InfiniteHits-loadMore).
   *
   * algolia_instant_search.js (app-eid fil — skrivebeskyttet i temaeditoren,
   * kan ikke endres derfra) kobler en alltid-aktiv IntersectionObserver som
   * selv trykker denne knappen så snart den — eller SIDENS FOOTER — blir
   * synlig, helt uavhengig av brukerhandling. Det er derfor "auto-scroll"
   * har virket alltid på. Siden vi ikke kan fjerne selve koblingen, blokkerer
   * vi i stedet EFFEKTEN: et script-utløst klikk (`.click()`) gir et
   * click-event med `isTrusted: false`, mens et ekte brukerklikk gir
   * `isTrusted: true`. En capture-fase-lytter på document stopper alle
   * ikke-tiltrodde klikk på knappen FØR de når frem — bortsett fra våre
   * egne bevisst utløste klikk (markert med et flagg) etter at brukeren selv
   * har aktivert automatisk rulling.
   */
  function initAlgoliaHybridLoadMore() {
    var settingsEl = document.querySelector('.product-grid-settings');
    var hybridScrollEnabled = !settingsEl || settingsEl.dataset.hybridScroll !== 'false';
    if (!hybridScrollEnabled) return;

    var container = document.querySelector('.ais-hits-container');
    if (!container) return;

    var autoScrollArmed = false;
    var ownProgrammaticClick = false;

    var sentinel = document.createElement('div');
    sentinel.className = 'product-grid-sentinel algolia-load-more-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    container.insertAdjacentElement('afterend', sentinel);

    function currentLoadMoreButton() {
      return container.querySelector('.ais-InfiniteHits-loadMore:not(.ais-InfiniteHits-loadMore--disabled)');
    }

    function relabelButton() {
      var btn = currentLoadMoreButton();
      if (!btn) return;
      if (btn.textContent.trim() !== 'Vis flere produkter') {
        btn.textContent = 'Vis flere produkter';
      }
      /* Knappen har ingen egen styling fra Algolia (var aldri ment å vises) — gi den samme utseende som resten av sidens knapper */
      btn.classList.add('button', 'button--secondary');
    }

    relabelButton();
    /* Algolia rerendrer knappen ved hver innlasting — hold tekst/klasser oppdatert */
    new MutationObserver(relabelButton).observe(container, { childList: true, subtree: true });

    function triggerLoadMore() {
      var btn = currentLoadMoreButton();
      if (!btn) return;
      ownProgrammaticClick = true;
      btn.click();
      ownProgrammaticClick = false;
    }

    var scrollObserver = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) triggerLoadMore();
    }, { rootMargin: '0px 0px 600px 0px' });

    /*
     * Én samlet lytter i fangst-fasen på document, i stedet for to separate
     * lyttere (én for blokkering på document, én for aktivering på
     * containeren) — unngår enhver usikkerhet rundt bobling/rekkefølge
     * mellom dem. Kjører FØR knappens egne Algolia-håndterere uansett.
     */
    document.addEventListener('click', function (event) {
      if (!event.target.closest('.ais-InfiniteHits-loadMore')) return;

      if (!event.isTrusted && !ownProgrammaticClick) {
        /* Appens egen alltid-aktive auto-klikk — blokker før den når knappen */
        event.stopImmediatePropagation();
        event.preventDefault();
        return;
      }

      if (!autoScrollArmed) {
        autoScrollArmed = true;
        container.classList.add('ais-hits-container--auto-scroll');
        scrollObserver.observe(sentinel);
      }
    }, true);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.subcategory-nav__wrapper').forEach(initCarousel);
    initReadMore();
    initProductGridLoadMore();
    initAlgoliaHybridLoadMore();
  });
})();